/**
 * 共通ローディングスピナーコンポーネント
 * 
 * 全画面で統一されたローディング表示を提供
 */
const LoadingSpinner = ({ message = '読み込み中...' }) => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 via-blue-50 to-white flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">{message}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
